import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 2v5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 7h12l4 9H2l4-9Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.17 16a3 3 0 1 0 5.66 0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LampCeiling";
const LampCeiling = memo(themed(Icon));
export {
  LampCeiling
};
//# sourceMappingURL=lamp-ceiling.js.map
